import styles from "./accept-terms.module.less";
import { PrimaryButton } from "../../../elements";
import { Checkbox, TCheckboxInternal } from "../../checkbox-group/checkbox-group";

type TAcceptTermsAndSubmitProps = {
  title: string;
  termsContent: React.ReactNode;
  onSubmitForm: () => void;
  isPostingForm?: boolean;
  submitButtonText?: string;
  submitButtonLoadingText?: string;
  checkboxProps: TCheckboxInternal;
};

const AcceptTermsAndSubmit = ({
  title,
  termsContent,
  onSubmitForm,
  isPostingForm,
  submitButtonText,
  submitButtonLoadingText,
  checkboxProps,
}: TAcceptTermsAndSubmitProps) => {
  return (
    <div className={styles.wrapper}>
      <h5 className={"mb-0"}>{title}</h5>
      {termsContent && <div>{termsContent}</div>}
      <div className={styles.checkbox}>
        <Checkbox {...checkboxProps} />
      </div>
      <PrimaryButton
        label={isPostingForm ? submitButtonLoadingText : submitButtonText}
        isLoading={isPostingForm}
        onClick={onSubmitForm}
      />
    </div>
  );
};

export default AcceptTermsAndSubmit;
